import React from 'react';
import BusinessDashboard from '../components/business/Dashboard';

const BusinessDashboardPage = () => {
  return <BusinessDashboard />;
};

export default BusinessDashboardPage;

// import React from 'react';

// const BusinessDashboardPage = () => {
//   return (
//     <h1>hello keshav</h1>
//   );
// };

// export default BusinessDashboardPage;
